// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { connect } from 'react-redux';
import { unsetAllPdbIdsSetCompareClose } from '../../../store/pdbComparison';
import type { Theme } from '../../../types';
import ButtonComponent from '../../button';
import { CompareItems, Container } from './atoms';

const CompareTitle = styled<any, Theme>('div')`
  padding: 0rem 1rem 0rem 1rem;
  font-size: 1.2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 5rem;
  align-items: center;
  align-self: stretch;
`;

const Remove = styled<any, Theme>('div')`
  cursor: pointer;
  border: 1px solid ${props => props.theme.pdbCompare.borderColor};
  width: 1.5rem;
  height: 1.5rem;
  margin-left: 1rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Icon = styled<any, Theme>('i')`
  font-size: .65rem;
  color: ${props => props.theme.pdbCompare.removeIcon};
  line-height: 0;
  &:before {
    vertical-align: bottom;
  }
`;

const Button = styled<typeof ButtonComponent, Theme>(ButtonComponent)`
  && {
    align-self: center;
  }
`;

const Title = styled<any, Theme>('p')`
  font-size: 1.125rem;
  font-weight: 600;
  flex: 1;
  cursor: pointer;
  line-height: 5rem;

  &::after {
    border-style: solid;
    border-width: 0 0 2px 2px;
    content: '';
    display: inline-block;
    height: .5rem;
    width: .5rem;
    margin-left: 10px;
    transform: rotateZ(136deg) translate(-5px, -5px);

    ${props => props.isOpen && css`
      margin-left: 10px;
      transform: rotate(-45deg) translate(8px, 2px);
    `}
  }
`;

type StateProps = {|
  isOpen: boolean,
|};

type DispatchProps = {|
  onClickRemoveAllCompareItems: Function,
|};

type OwnProps = {|
  isOpen: boolean,
  pdbIds: Array<string>,
  carSelectedText: string,
  carsSelectedText: string,
  buttonCompareCarsText: string,
  comparePageLink: string,
  onTogglePdbCompare: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const PdbCompare = ({
  onTogglePdbCompare,
  isOpen,
  pdbIds,
  carSelectedText,
  carsSelectedText,
  buttonCompareCarsText,
  onClickRemoveAllCompareItems,
  comparePageLink,
}: Props) => {
  if (pdbIds.length === 0) {
    return null;
  }

  return (
    <Container isOpen={isOpen}>
      <CompareTitle>
        <Title isOpen={isOpen} onClick={onTogglePdbCompare}>
          {pdbIds.length}
          {' '}
          {pdbIds.length === 1 ? carSelectedText : carsSelectedText}
        </Title>
        <Button disabled={pdbIds.length === 1} href={comparePageLink} size="small" caret hasMargin={false}>
          {buttonCompareCarsText}
        </Button>
        <Remove onClick={onClickRemoveAllCompareItems}>
          <Icon className="icon-cross" />
        </Remove>
      </CompareTitle>
      <CompareItems
        pdbIds={pdbIds}
      />
    </Container>
  );
};

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  onClickRemoveAllCompareItems: () => dispatch(unsetAllPdbIdsSetCompareClose()),
});


export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  null,
  mapDispatchToProps,
)(PdbCompare);
